export default __webpack_public_path__ + "locales/hy-AM/Translations.json?hash=e1970f943a8fd8ccacdbf2fc6e32fe4b";